import { forwardRef, ForwardedRef } from 'react'
import Button from '@mui/material/Button'
import { buttonTertiaryStyles } from './Button.styles'
import { ButtonProps } from './Button.types'
import { SxProps } from '@mui/system'

const ButtonTertiary = forwardRef(
  (
    {
      children,
      size = 'large',
      disabled = false,
      loading = false,
      sx = {},
      ...extraProps
    }: ButtonProps,
    ref: ForwardedRef<HTMLButtonElement>
  ) => {
    return (
      <Button
        ref={ref}
        sx={{ ...buttonTertiaryStyles, ...sx } as SxProps}
        variant="contained"
        color="primary"
        size={size}
        {...extraProps}
        disabled={disabled || loading}
        disableRipple={true}
      >
        {children}
      </Button>
    )
  }
)

export default ButtonTertiary
